var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecretFans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.5347C11.7335 10.8218 13.2663 10.8218 14.4999 11.5347M9.32843 9.17157C10.8905 10.7337 10.8905 13.2663 9.32843 14.8284C7.76634 16.3905 5.23367 16.3905 3.67157 14.8284C2.10948 13.2663 2.10948 10.7337 3.67157 9.17157C5.23366 7.60948 7.76633 7.60948 9.32843 9.17157ZM21.3284 9.17157C22.8905 10.7337 22.8905 13.2663 21.3284 14.8284C19.7663 16.3905 17.2337 16.3905 15.6716 14.8284C14.1095 13.2663 14.1095 10.7337 15.6716 9.17157C17.2337 7.60948 19.7663 7.60948 21.3284 9.17157Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretFans);
export default __webpack_public_path__ + "static/media/secret_fans.6b0069ebf6bd72b5c1ee13bea72e78e3.svg";
export { ForwardRef as ReactComponent };